// autogenerated
import {IIconProps} from "@reapptor-apps/reapptor-react-components";
import {VisitingPointDuration, CruiseGroupSize, CruiseTimeOfDay, CruiseDuration, CruiseExtra, CruiseOrderState} from "@/models/Enums";
import User from "@/models/server/User";
import CruiseCountry from "@/models/server/CruiseCountry";
import CruiseArea from "@/models/server/CruiseArea";

export default class CruiseOrder {

    public id: string = "";

    public captainId: string | null = null;

    public captain: User | null = null;

    public countryId: string | null = null;

    public country: CruiseCountry | null = null;

    public areaId: string | null = null;

    public area: CruiseArea | null = null;

    public customArea: string | null = null;

    public departFrom: string | null = null;

    public departBy: Date = new Date();

    public visitPoint: string | null = null;

    public visitingPointDuration: VisitingPointDuration | null = null;

    public arriveTo: string | null = null;

    public arriveAt: Date = new Date();

    public groupSize: CruiseGroupSize = CruiseGroupSize.Standard;

    public numberOfComingChildren: number | null = null;

    public childrenComing: boolean = false;

    public accessibilityLimitations: boolean = false;

    public accessibilityLimitationsComment: string | null = null;

    public timeOfDay: CruiseTimeOfDay = CruiseTimeOfDay.Morning;

    public duration: CruiseDuration = CruiseDuration.JustRide;

    public extras: CruiseExtra[] | null = null;

    public state: CruiseOrderState = CruiseOrderState.New;

    public date: Date = new Date();

    public groupSizeValue: number = 0;

    public comment: string | null = null;

    public estimatedPrice: number | null = null;

    public name: string | null = null;

    public company: string | null = null;

    public email: string | null = null;

    public phone: string | null = null;

    public language: string | null = null;

    public createdAt: Date = new Date();

    public createdById: string = "";

    public modifiedAt: Date = new Date();

    public modifiedById: string = "";

    public readonly isCruiseOrder: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof CruiseOrder) || ((from as any).isCruiseOrder === true));
    }

    public static as(from?: object | null): CruiseOrder | null {
        return (CruiseOrder.is(from)) ? from as CruiseOrder : null;
    }

    // #region Placeholder

    public static getAccessibilityLimitationsIcon(cruiseOrder: CruiseOrder): IIconProps {
        return (cruiseOrder.accessibilityLimitations)
            ? {name: "far check-circle", className: "green", tooltip: cruiseOrder.accessibilityLimitationsComment}
            : {name: ""};
    }

    // #endregion
}